import React from "react";
import { ReactComponent as ReverseIcon } from "../../img/trade-interface/Reverse.svg";
import { ReverseButton } from "./elements/ReverseButton";

export interface ReverseTokensProps {
  isVisible: boolean;
  onClick: () => void;
  isWrap?: boolean;
}

export const ReverseTokensButton: React.FC<ReverseTokensProps> = props => {
  if (!props.isVisible) {
    return null;
  }

  return (
    <ReverseButton
      onClick={() => props.onClick()}
      data-testid={`${props.isWrap ? "wrap-" : ""}reverse-tokens-btn`}
    >
      <ReverseIcon />
    </ReverseButton>
  );
};
